/**
 * 請求先情報
 */
export class InvoiceToInfo {
    /** 請求先名称 */
    invoiceToName = ""
		/** 請求先名敬称*/
		invoiceToNameHonorific = ""
    /** 請求先郵便番号 (999-9999) */
    invoiceToZipCode = ""
    /** 請求先住所１ */
    invoiceToAddress1 = ""
    /** 請求先住所２ */
    invoiceToAddress2 = ""
    /** 請求先部署名 */
    invoiceToDepartment = ""
    /** 請求先役職 */
    invoiceToPosition = ""
    /** 請求先担当者名 */
    invoiceToContact = ""
    /** 請求先電話番号 */
    invoiceToTel = ""
    /** 請求先FAX番号 */
    invoiceToFax = ""
    /** 請求先メールアドレス */
    invoiceToMail = ""
    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<InvoiceToInfo>) {
        Object.assign(this, init)
    }
}
